import { Calendar } from "primereact/calendar";

export function DateFilter() {
    return (
        <div className="date-filter-div">
            <Calendar
                className="date-filter-calendar"
                value={new Date()}
                // onChange={(event: any) => console.log(event.value)}
                inline
                showOtherMonths={false}
                selectionMode="single"
                maxDate={new Date()}
            />
        </div>
    )
}
